import { createFileRoute, Outlet } from '@tanstack/react-router'
import { RouteLayout } from '@web/app/components'
import { Shield } from '@tamagui/lucide-icons'

export const Route = createFileRoute('/_index/security')({
  component: RouteComponent,
  staticData: {
    metaRoute: {
      title: 'Seguridad',
      icon: Shield,
    },
  },
})

function RouteComponent() {
  return (
    <RouteLayout>
<Outlet />
    </RouteLayout>
  )
}
